import React, { useState, useEffect } from "react";
import Table from "@material-ui/core/Table";
import TableContainer from "@material-ui/core/TableContainer";
import Paper from "@material-ui/core/Paper";
import UserService from "../services/user-service";
import Popup from "reactjs-popup";
import "reactjs-popup/dist/index.css";
import EUPopup from "../components/updateExpensePop";
import ERPopup from "../components/removeExpensePop";
import ECPopup from "../components/copyExpensePop";
import { ReactComponent as EditPic } from "../assets/editpencil.svg";
import { ReactComponent as RemovePic } from "../assets/redfilltrash.svg";
import { ReactComponent as CopyPic } from "../assets/duplicate2.svg";
import { ReactComponent as ActionIcon } from "../assets/actionIcon.svg";
import { ReactComponent as AddImage } from "../assets/addImage.svg";
import { ReactComponent as ReplaceImage } from "../assets/replaceImage.svg";
import { ReactComponent as ExportIcon } from "../assets/exportIcon.svg";
import { ReactComponent as SearchIcon } from "../assets/searchIcon.svg";
import Tooltip from "@mui/material/Tooltip";
import Popover from "@mui/material/Popover";
import "bootstrap/dist/css/bootstrap.min.css";
import "react-bootstrap-table2-filter/dist/react-bootstrap-table2-filter.min.css";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import BootstrapTable from "react-bootstrap-table-next";
import filterFactory, {
  selectFilter,
  dateFilter,
  Comparator,
} from "react-bootstrap-table2-filter";
import { Col } from "react-bootstrap";
import paginationFactory from "react-bootstrap-table2-paginator";
import ToolkitProvider, {
  Search,
  CSVExport,
} from "react-bootstrap-table2-toolkit";
import { useLocation } from "react-router-dom";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import moment from "moment";
import jsPDF from "jspdf";
import "jspdf-autotable";
import "../styling/table.css";
import Form from "react-bootstrap/Form";
import { toast } from "react-toastify";
import EIPopup from "./imageHandlers/uploadExpenseReceiptDirect";
import ReactGA from "react-ga";

interface CustomizedState {
  stream: number;
}
//creating the database
function createData(name, date, amount, site, category, note) {
  return { name, date, amount, site, category, note };
}

const rows = [
  createData(
    "Hand plane",
    "4/9/21",
    "$10.00",
    "Lowe's",
    "Workshop tools",
    "Replacement"
  ),
  createData("Oak 4 x 4 x 4", "4/21/21", "$37.00", "Lowe's", "Lumber", 0),
  createData(
    "Dado blade",
    "5/10/21",
    "$50.00",
    "Lowe's",
    "Workshop tools",
    "Drawer"
  ),
  createData("Sandpaper", "6/9/21", "$10.00", "Lowe's", "Supplies", "Bench"),
];

const colors = [
  "#21A179",
  "#7964D9",
  "#EB6F2D",
  "#98B514",
  "#0DA4B5",
  "#FFD436",
  "#FAAC02",
  "#EA4147",
  "#FC6897",
  "#006895",
];

interface Dictionary<T> {
  [Key: string]: T;
}

export default function BasicTable(props) {
  const [toLoading, setToLoading] = useState(true);
  const [nrows, setnRows] = useState(rows);
  const [, setCategories] = useState([""]);
  const [uname, setuname] = useState([]);
  const [showUpdate, setShowUpdate] = useState(false);
  const [showRemove, setShowRemove] = useState(false);
  const [showDuplicate, setShowDuplicate] = useState(false);
  const [tempData, setTempData] = useState<any>({});
  const [fileName, setFileName] = useState("");
  const [buttonType, setButtonType] = useState("");
  const [openExportModal, setOpenExportModal] = useState(false);
  const [openImageModal, setOpenImageModal] = useState(false);
  const [openUpdateImageModal, setOpenUpdateImageModal] = useState(false);
  const [reloadTableData, setReloadTableData] = useState(false);
  const location = useLocation();
  const statevars = location.state as CustomizedState;
  const [openActionModal, setOpenActionModal] =
    useState<HTMLButtonElement | null>(null);

  const handleClick = (event) => {
    setOpenActionModal(event.currentTarget);
  };

  const handleClose = () => {
    setOpenActionModal(null);
  };

  const eventTrackItem = (category, action, label) => {
      //console.log("GA event:", category, ":", action, ":", label);
      ReactGA.event({
        category: category,
        action: action,
        label: label,
      });
    };

  const open = Boolean(openActionModal);
  const id = open ? "simple-popover" : undefined;

  function actionformat(cell, row) {
    return (
      <>
        <div className="d-flex align-items-center justify-content-center">
          <div>
            <ActionIcon
              aria-describedby={id}
              onClick={(e) => {
                setTempData(row);
                handleClick(e);
              }}
              className="action-icon"
            />
          </div>
          {
          (!row.receiptImg ) ?
            (
              <div>
                <Tooltip
                  title={`${
                    row.receiptImg
                      ? "View receipt/invoice"
                      : "Upload an image of a expense receipt or invoice"
                  }`}
                  placement="left"
                >
                  <button
                    className="actionbuttonE"
                    onClick={() => {
                      setOpenImageModal(true);
                      setTempData(row);
                    }}
                  >
                    <div className="popover-btn">
                      <AddImage className="add-image" />
                    </div>
                  </button>
                </Tooltip>
              </div>
            )
          :
            (
              <div>
              <Tooltip
                title="Update Image"
                placement="left"
              >
                <button
                  className="actionbuttonE"
                  onClick={() => {
                    setOpenUpdateImageModal(true);
                    setTempData(row);
                  }}
                >
                  <div className="popover-btn">
                    <ReplaceImage className="add-image m-0" />
                  </div>
                </button>
              </Tooltip>
            </div>
            )
          }
         
          <Popover
            id={id}
            open={open}
            anchorEl={openActionModal}
            onClose={handleClose}
            anchorOrigin={{
              vertical: "center",
              horizontal: "right",
            }}
            transformOrigin={{
              vertical: "center",
              horizontal: "right",
            }}
            className="action-modal expense-action mr-3"
          >
            <div className="d-flex flex-column">
              <button
                className="actionbuttonE"
                onClick={() => {
                  setShowUpdate(!showUpdate);
                  setOpenActionModal(null);
                  setShowRemove(false);
                  setShowDuplicate(false);
                }}
              >
                {" "}
                <div className="popover-btn">
                  <EditPic stroke="grey" />
                  <span className="pr-2">Update</span>
                </div>
              </button>
              <hr className="m-0" />
              <button
                className="actionbuttonE"
                onClick={() => {
                  setShowUpdate(false);
                  setOpenActionModal(null);
                  setShowRemove(false);
                  setShowDuplicate(!showDuplicate);
                }}
              >
                {" "}
                <div className="popover-btn">
                  <CopyPic className="ml-1" stroke="grey" />
                  <span className="pl-2">Duplicate</span>
                </div>
              </button>
              <hr className="m-0" />
              <button
                className="actionbutton removebuttonE"
                onClick={() => {
                  setShowUpdate(false);
                  setOpenActionModal(null);
                  setShowRemove(!showRemove);
                  setShowDuplicate(false);
                }}
              >
                <div className="popover-btn">
                  <RemovePic /> <span className="pr-1">Remove</span>
                </div>
              </button>
              <hr className="m-0" />
            </div>
          </Popover>
        </div>
      </>
    );
  }

  function createColorDictionary(data) {
    var colorDict: Dictionary<string> = {};
    const uniqueCats: any[] = [
      ...Array.from(new Set(data.map((item) => item["category"]))),
    ];
    setCategories(uniqueCats);
    var colorindex = 0;
    for (let i = 0; i < uniqueCats.length; i++) {
      if (i >= colors.length) {
        colorindex = i % colors.length;
      } else {
        colorindex = i;
      }
      colorDict[uniqueCats[i]] = colors[colorindex];
    }
    return colorDict;
  }

  function getColor(cell) {
    const colorDict = createColorDictionary(nrows);
    return colorDict[cell];
  }

  function amountformat(cell, row) {
    return <span> ${cell} </span>;
  }

  function categoryformat(cell, row, value) {
    return (
      cell !== "" ? (
        <div
          className="category-cell"
          style={{ backgroundColor: getColor(cell) }}
        >
          {cell}
        </div>
      ):""
    );
  }

  const { SearchBar, ClearSearchButton } = Search;
  const { ExportCSVButton } = CSVExport;

  const uniqueCatagory: any[] = [
    ...Array.from(new Set(nrows.map((item) => item["category"]))),
  ];

  const categoryOptions: any = uniqueCatagory.filter(Boolean).map((item) => ({
    label: item,
    value: item,
  }));

  //the expense table
  const columns = [
    {
      dataField: "name",
      text: "Name",
      sort: true,
      headerClasses: "column-header column-header-name",
      classes: "column-name",
    },
    {
      dataField: "date",
      text: "Date",
      filter: dateFilter({
        defaultValue: { comparator: Comparator.EQ },
        comparatorStyle: { display: "none" },
        dateStyle: { width: "7.5vw", paddingLeft: "3px" },
      }),
      formatter: (date, row) => {
        return (
          <p
            data-toggle="tooltip"
            data-placement="top"
            title={
              row.realDate &&
              moment(row.realDate).format("hh:mm") +
                "\n" +
                moment(row.realDate).format("dddd")
            }
          >
            {date}
          </p>
        );
      },
      sort: true,
      sortFunc: (a, b, order, dataField, rowA, rowB) => {
        const dateA = new Date(a);
        const dateB = new Date(b);
        if (order === "asc") {
          return dateA.getTime() - dateB.getTime();
        }
        return dateB.getTime() - dateA.getTime();
      },
      headerClasses: "column-header column-date-field",
      classes: "column-data",
    },
    {
      dataField: "amount",
      text: "Amount",
      sort: true,
      sortFunc: (a, b, order, dataField) => {
        if (order === "asc") {
          return (
            parseFloat(a.replace(",", "")) - parseFloat(b.replace(",", ""))
          );
        }
        return parseFloat(b.replace(",", "")) - parseFloat(a.replace(",", "")); // desc
      },
      formatter: amountformat,
      headerClasses: "column-header text-center",
      classes: "column-data text-center",
    },
    {
      dataField: "site",
      text: "Purchased From",
      headerClasses: `column-header non-sortable ${
        props.sideBar ? `column-purchase-form` : ""
      }`,
      classes: "column-data",
    },
    {
      dataField: "category",
      text: "Category",
      formatter: categoryformat,
      sort: true,
      filter: selectFilter({
        options: categoryOptions,
      }),
      headerClasses: "column-header",
      classes: "column-data",
    },
    {
      dataField: "note",
      text: "Note",
      headerClasses: "column-header non-sortable text-center",
      classes: "column-data text-center",
    },
    {
      dataField: "actions",
      text: "",
      formatter: actionformat,
      csvExport: false,
      headerClasses: "column-header non-sortable text-center",
      classes: "column-data text-center",
      formatExtraData: openActionModal,
    },
  ];

  useEffect(() => {
    UserService.getIncome().then((response) => {
      setuname(response.data.iname);
    });
    UserService.getExpense().then((response) => {
      const filtered = UserService.getSpecificExpense(
        response.data.expense,
        props.stream + 1
      );
      filtered.reverse().forEach((item) => {
        item.date = moment(item.date).format("MMM DD yyyy");
        item.amount = item.amount.toLocaleString(undefined, {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        });
      });
      setnRows(filtered);
      setToLoading(false);
    });
  }, [props.stream, statevars?.stream,props.reloadAPI,reloadTableData]);

  // for pdf
  const generatePDF = (data) => {
    const doc: any = new jsPDF("l", "mm", "a4");
    const title = "Expense Report";
    const headers = [["Name", "Date", "Amount", "Site", "Category", "Note"]];

    const result = data.map((elt) => [
      elt.name,
      elt.date,
      elt.amount,
      elt.site,
      elt.category,
      elt.note,
    ]);

    const content = {
      startY: 50,
      head: headers,
      body: result,
    };

    doc.text(title, 35, 40, "center");
    doc.autoTable(content);
    doc.save(fileName !== "" ? `${fileName}.pdf` : "Expense.pdf");
  };

  if (toLoading) {
    return (
      <TableContainer component={Paper}>
        <Table></Table>
      </TableContainer>
    );
  }

  const renderPageList = (options) => (
    <Col className="react-bootstrap-table-pagination-list" md={6}>
      <ul className="pagination react-bootstrap-table-page-btns-ul float-right">
        {options.pages.map((page) => (
          <li
            key={page.page}
            className={`${page.active ? "active-page" : ""}page-item ${page.disabled ? "disable-page" :""}`}
            onClick={() => options.onPageChange(page.page)}
          >
            <div className="page-link">
              {page.page}
            </div>
          </li>
        ))}
      </ul>
    </Col>
  );

  const pagination = paginationFactory({
    sizePerPage: 20,
    firstPageText: "<<",
    lastPageText: ">>",
    alwaysShowAllBtns: true,
    showTotal: true,
    pageListRenderer: renderPageList,
  });

  return (
    <div>
      <Popup open={openImageModal} onClose={() => setOpenImageModal(false)}>
        <div className="mode">
          <button className="close" onClick={() => setOpenImageModal(false)}>
            &times;
          </button>
          <div className="header">
            {tempData?.receiptImg ? "View Image" : "Upload Image"}
          </div>
          <div className="content">
            <EIPopup keydata={tempData} closeImageModel={setOpenImageModal} setReloadTableData={setReloadTableData} isUpdateImage={false}/>
            <br />
          </div>
        </div>
      </Popup>

      <Popup open={openUpdateImageModal} onClose={() => setOpenUpdateImageModal(false)}>
        <div className="mode">
          <button className="close" onClick={() => setOpenUpdateImageModal(false)}>
            &times;
          </button>
          <div className="header">
            Update Image
          </div>
          <div className="content">
            <EIPopup keydata={tempData} closeImageModel={setOpenUpdateImageModal} setReloadTableData={setReloadTableData} isUpdateImage={true}/>
            <br />
          </div>
        </div>
      </Popup>

      <Popup open={showUpdate} onClose={() => setShowUpdate(false)}>
        <div className="mode">
          <button className="close" onClick={() => setShowUpdate(false)}>
            &times;
          </button>
          <div className="header"> Update Expense </div>
          <div className="content">
            {" "}
            <EUPopup keydata={tempData} categories={props.categories} closeUpdateModel={setShowUpdate} setReloadTableData={setReloadTableData} setReloadAPI={props.setReloadAPI}></EUPopup>
            <br />
          </div>
        </div>
      </Popup>
      <Popup open={showDuplicate} onClose={() => setShowDuplicate(false)}>
        <div className="mode">
          <button className="close" onClick={() => setShowDuplicate(false)}>
            &times;
          </button>
          <div className="header"> Duplicate Expense </div>
          <div className="content">
            {" "}
            <ECPopup keydata={tempData} categories={props.categories} closeDuplicateModel={setShowDuplicate} setReloadTableData={setReloadTableData} setReloadAPI={props.setReloadAPI}></ECPopup>
            <br />
          </div>
        </div>
      </Popup>
      <Popup open={showRemove} onClose={() => setShowRemove(false)}>
        <div className="mode">
          <button className="close" onClick={() => setShowRemove(false)}>
            &times;
          </button>
          <div className="header"> Remove Expense </div>
          <div className="content">
            {" "}
            <ERPopup keydata={tempData} categories={props.categories} closeRemoveModel={setShowRemove} setReloadTableData={setReloadTableData} setReloadAPI={props.setReloadAPI}></ERPopup>
            <br />
          </div>
        </div>
      </Popup>
      <ToolkitProvider
        keyField="id"
        data={nrows}
        columns={columns}
        search
        exportCSV={{ fileName: `${fileName}.csv` }}
      >
        {(props) => (
          <>
            <div className="py-3">
              <span className="tabletitle"> Expenses </span>
              <SearchIcon id="filtersubmit" className="mr-5" />
              <SearchBar {...props.searchProps} placeholder=" " />
              <ClearSearchButton {...props.searchProps} className="btn-clear" />
              <ExportCSVButton
                className="export-button export-button-csv"
                onClick={() => {
                  eventTrackItem("Export", "CSV", "Button");
                  setOpenExportModal(true);
                  setButtonType("CSV");
                  setFileName("");
                }}
              >
                <ExportIcon className="mr-2 mb-2 export-icon" />
                Export To CSV
              </ExportCSVButton>
              <button
                className="export-button btn btn-default export-button-pdf"
                onClick={() => {
                  eventTrackItem("Export", "PDF", "Button");
                  setOpenExportModal(true);
                  setButtonType("PDF");
                  setFileName("");
                }}
              >
                <ExportIcon className="mr-2 mb-2 export-icon" />
                Export To PDF
              </button>
              <Dialog
                open={openExportModal}
                onClose={() => setOpenExportModal(false)}
                className="export-modal"
              >
                <DialogTitle className="pt-3 pb-0">
                  {buttonType === "CSV" ? "Export To CSV" : "Export To PDF"}
                </DialogTitle>
                <DialogContent>
                  <TextField
                    autoFocus
                    autoComplete="off"
                    value={fileName}
                    margin="dense"
                    id="name"
                    label="Enter File Name"
                    type="text"
                    fullWidth
                    variant="standard"
                    onChange={(e) => setFileName(e.target.value)}
                  />
                </DialogContent>
                <DialogActions>
                  <Button
                    onClick={() => setOpenExportModal(false)}
                    className="export-modal-button mb-2"
                  >
                    Cancel
                  </Button>
                  {buttonType === "CSV" ? (
                    <div
                      onClick={() => setOpenExportModal(false)}
                      className="export-modal-button mb-2 ml-3"
                    >
                      <ExportCSVButton {...props.csvProps}>
                        Export CSV{" "}
                      </ExportCSVButton>
                    </div>
                  ) : (
                    <Button
                      onClick={() => {
                        generatePDF(props.baseProps.data);
                        setOpenExportModal(false);
                      }}
                      className="export-modal-button mb-2"
                    >
                      Export PDF
                    </Button>
                  )}
                </DialogActions>
              </Dialog>
            </div>
            <BootstrapTable
              {...props.baseProps}
              bordered={false}
              filter={filterFactory()}
              pagination={pagination}
              filterPosition="top"
              rowClasses="table-hover"
              noDataIndication="Add Expenses above"
              placement="top"
              wrapperClasses="responsive"
            />
          </>
        )}
      </ToolkitProvider>
      {/*<BootstrapTable keyField='id' data={ nrows } columns={ columns } bordered={ false }  filter={ filterFactory() } filterPosition="top" noDataIndication="Add Expenses above"  />
       */}
      {/*
    <TableContainer component={Paper}>
      <Table className={classes.table} aria-label="simple table">
        <TableHead>
          <TableRow>
            <TableCell className={classes.tableHead}>Name</TableCell>
            <TableCell align="center" className={classes.tableHead}>Date</TableCell>
            <TableCell align="right" className={classes.tableHead}>Amount</TableCell>
            <TableCell align="right" className={classes.tableHead}>Purchased From</TableCell>
            <TableCell align="right" className={classes.tableHead}>Category</TableCell>
            <TableCell align="right" className={classes.tableHead}>Note</TableCell>
            <TableCell align="right" className={classes.tableHead}>Actions</TableCell>
          </TableRow>
        </TableHead>
        */}
      {/*
        <TableBody>
          {rows.map((row) => (
            <TableRow key={row.name}>
              <TableCell component="th" scope="row">
                {row.name}
              </TableCell>
              <TableCell align="right">{row.date}</TableCell>
              <TableCell align="right">{row.amount}</TableCell>
              <TableCell align="right">{row.site}</TableCell>
              <TableCell align="right">{row.cat}</TableCell>
              <TableCell align="right">{row.note}</TableCell>
            </TableRow>
          ))}
        </TableBody>
        */}
      {/*
        <TableBody>
          {nrows.map((nrow) => (
            <TableRow key={nrow.name}>
              <TableCell component="th" scope="row">
                {nrow.name}
              </TableCell>
              <TableCell align="center">{nrow.date}</TableCell>
              <TableCell align="right">${nrow.amount}</TableCell>
              <TableCell align="right">{nrow.site}</TableCell>
              <TableCell align="right">{nrow.category}</TableCell>
              <TableCell align="right">{nrow.note}</TableCell>
              <TableCell align="right">
              <Popup
                trigger={<button className="actionbutton"> Edit </button>}
                modal
                nested
              >
              {close => (
                <div className="mode">
                  <button className="close" onClick={close}>
                    &times;
                  </button>
                  <div className="header"> Update Expense </div>
                  <div className="content">
                    {' '}
                    <EUPopup keydata={nrow} categories={props.categories}></EUPopup>
                    <br />
                  </div>
                </div>
              )}
            </Popup>
            <Popup
              trigger={<button className="actionbutton removebutton"> Remove </button>}
              modal
              nested
            >
            {close => (
              <div className="mode">
                <button className="close" onClick={close}>
                  &times;
                </button>
                <div className="header"> Remove Income Source </div>
                <div className="content">
                  {' '}
                  <ERPopup keydata={nrow} categories={props.categories}></ERPopup>
                  <br />
                </div>
              </div>
            )}
          </Popup>
          </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  */}
    </div>
  );
}

/*
  { (!row.receiptImg || row.receiptImg == '') &&
  <Popup
    trigger={<button className="actionbutton"> Add Image </button>}
    modal
    nested
  >
  {close => (
    <div className="mode">
      <button className="close" onClick={close}>
        &times;
      </button>
      <div className="header"> Add Receipt </div>
      <div className="content">
        {' '}
        <EIPopup keydata={row} categories={props.categories}></EIPopup>
        <br />
      </div>
    </div>
  )}
</Popup>
}

{ (row.receiptImg && row.receiptImg != '') &&
<Popup
  trigger={<button className="actionbutton"> View Image </button>}
  modal
  nested
>
{close => (
  <div className="mode">
    <button className="close" onClick={close}>
      &times;
    </button>
    <div className="header"> Receipt </div>
    <div className="content">
      {' '}
      <EVPopup keydata={row} categories={props.categories}></EVPopup>
      <br />
    </div>
  </div>
)}
</Popup>
}
*/
